import React from 'react';
import { Col, Container, Row, Button } from 'reactstrap';
import { T } from '../traks';
import { A } from '../routes';
import SearchField from '../c/SearchField';
import { Apify } from '../Apify';
import store from '../store';
import { StockCard } from '../c/ChartCard';
import XTab from '../c/XTab';
import { connect } from 'react-redux';


var ExploreMarkets = (props) => {
	return (
		<Container>
			<Row className="p-5 d-flex">
				<Col xs="12" md="12" className="d-flex justify-content-center font-weight-bold">
					Find og køb værdipapirer
				</Col>
				<Col xs="12" md="12" className="d-flex justify-content-center py-3">
					<a className="xyzzy_button" href="/explore-cph">Danske værdipapirer</a>
				</Col>
				<Col xs="12" md="12" className="d-flex justify-content-center gap-20 font-weight-bold">
					<span>Andre:</span>
					<a className="txt-color-green" href="/explore-us">USA</a>
                    <a className="txt-color-green" href="/explore-xetra">Tyske</a>
                    <a className="txt-color-green" href="/explore-sto">Svenske</a>
				</Col>
			</Row>
		</Container>
	);
}

ExploreMarkets = connect(
	(state) => ({
		me: state.me,
		games_xtab_index: state.home_games_xtab_index,
		stocklist_xtab_index: state.home_stocklist_xtab_index,
		stocklist_interval_xtab_index: state.home_stocklist_interval_xtab_index,
	})
)(ExploreMarkets);

export default ExploreMarkets;



// WEBPACK FOOTER //
// ./src/p/ExploreMarkets.js